import store from '../../../src/store';

// TODO: refactor - separate logic to services
class StoreService {
  initOverride() {
    store.subscribeAction({
      after: ({type}, state) => {
        switch (type) {
          /**
           * Product
           */
          case 'shopify/product/initProductHandle':
            // set handle to null in order to skip ajax load
            store.commit('shopify/product/handle', null);
            break;
          case 'shopify/product/loadProductByHandle':
            // set shopify product to loaded dev product
            store.commit('shopify/product/set', store.getters['dev/shopify/product/get']);
            break;

          /**
           * Order
           */
          case 'shopify/order/init':
            // set shopify order to loaded dev product
            store.commit('shopify/order/set', store.getters['dev/shopify/order/get']);
            break;
        };
      },
    });
  }
}

export default new StoreService();
